/**
 * DIISEA Sticky ATC:
 * - Show only after scrolling past the Main product section
 * - Keep sticky price in sync when variants change
 * - Does not replace Kalles cart / loading behavior
 */
(function () {
  var SHOWN_CLASS = 'diisea-sticky-shown';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = (Number(cents) || 0) / 100;
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      var parts = (number.toFixed(precision) + '').split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    switch ((formatString.match(placeholderRegex) || [])[1]) {
      case 'amount':
        value = formatWithDelimiters(value, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(value, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(value, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(value, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(value, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(value, 2);
    }
    return formatString.replace(placeholderRegex, value);
  }

  function updatePrice(root, variant) {
    if (!root || !variant) return;
    var priceEl = root.querySelector('[data-diisea-sticky-price]');
    if (!priceEl) return;
    var format =
      priceEl.getAttribute('data-money-format') ||
      (window.themeHDN && window.themeHDN.moneyFormat) ||
      '${{amount}}';
    priceEl.textContent = formatMoney(variant.price, format);
  }

  function getMainProductSection(root) {
    return (
      root.closest('.shopify-section.hdt-section--feature-product') ||
      root.closest('#MainContent .shopify-section') ||
      root.closest('.shopify-section') ||
      document.querySelector('.shopify-section.hdt-section--feature-product') ||
      document.querySelector('main .hdt-section--feature-product') ||
      document.querySelector('.hdt-section--feature-product')
    );
  }

  function setShown(show) {
    document.body.classList.toggle(SHOWN_CLASS, !!show);
  }

  function syncVisibility(section) {
    if (!section) return;
    // Past Main product = section bottom has left the top of the viewport
    var past = section.getBoundingClientRect().bottom <= 0;
    setShown(past);
  }

  function bindTrigger(root) {
    if (root.dataset.diiseaStickyTriggerBound === 'true') return;
    root.dataset.diiseaStickyTriggerBound = 'true';

    var mode = root.getAttribute('data-sticky-mode') || '';
    if (mode === 'hdt_show_always') {
      setShown(true);
      return;
    }

    var section = getMainProductSection(root);
    if (!section) return;

    var raf = null;
    function onScrollOrResize() {
      if (raf) return;
      raf = window.requestAnimationFrame(function () {
        raf = null;
        syncVisibility(section);
      });
    }

    syncVisibility(section);

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function () {
          syncVisibility(section);
        },
        { threshold: [0, 0.01, 0.1, 1] }
      );
      io.observe(section);
      root._diiseaStickyIo = io;
    }

    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    root._diiseaStickyOnScroll = onScrollOrResize;
  }

  function bindPrice(root) {
    if (!root || root.dataset.diiseaStickyBound === 'true') return;
    root.dataset.diiseaStickyBound = 'true';

    var form = root.querySelector('wrapp-hdt-pr-frm form') || root.querySelector('form');
    if (form) {
      form.addEventListener('variant:change', function (event) {
        updatePrice(root, event && event.detail && event.detail.variant);
      });
    }

    root.addEventListener(
      'change',
      function (event) {
        var select = event.target;
        if (!select || !select.matches || !select.matches('select[tag-select]')) return;
        var option = select.options[select.selectedIndex];
        if (!option) return;
        var price = option.getAttribute('data-price');
        if (price == null) return;
        updatePrice(root, { price: price });
      },
      true
    );
  }

  function bindSticky(root) {
    bindPrice(root);
    bindTrigger(root);
  }

  function init() {
    document.querySelectorAll('hdt-sticky-btn-atc.diisea-sticky-atc').forEach(bindSticky);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
